import React, { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const Logout = () => {
const { logout } = useAuth();
const navigate = useNavigate();
 useEffect(() => {
    logout();
    navigate('/auth');
  }, [logout, navigate]);
  return true
};

export default Logout;
